import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ClassesService {

  constructor(private  httpClient:  HttpClient) {}

  getClassesCreateList(params){
    return this.httpClient.get("/academics/get_class_creation_list/",{params:params})
  }

  getClassess() {
    return this.httpClient.get('/academics/classes/');
  }
  getClasses(id) {
    return this.httpClient.get('/academics/classes/',{params:{id}});
  }
  postClasses(classes) {
    return this.httpClient.post('/academics/classes/', classes);
  }
  updateClasses(classes) {
    return this.httpClient.post('/academics/classes/', classes);
  }

  getClassessforaddexam() {
    return this.httpClient.get('/academicactivites/getclassessforaddexam/');
  }
  getdivisions(class_name) {
    return this.httpClient.get('/academics/listdivisions/', { params: { 'class_name': class_name } });
  }
  getdistinctclasses() {
    return this.httpClient.get('/academics/distinctclass/');
  }
  getteacherClasses() {
    return this.httpClient.get('/academics/teachersclass/');
  }
  getClassofTeacher(){
    return this.httpClient.get('/academics/classofteacher/');
  }
  getAssignClassofTeacher(){
    return this.httpClient.get('/academics/teacherassignclass/');
  }
  getClassSubject(id){
    return this.httpClient.get('/academics/get_class_all_subject/',{params:{'id':id}});
  }
  getClassonDesc(){
    return this.httpClient.get('/academics/get_class_desc_order/');
  }
  getClassName(){
    return this.httpClient.get('/academics/get_class_name_only/');
  }
  getActiveStudentClass(){
    return this.httpClient.get('/academics/active_student_class/')
  }
  getStudentClass(student_id,academic_year){
    return this.httpClient.get('/academics/get_student_class/',{params:{'student_id':student_id,'academic_year':academic_year}})
  }
  getClassStudents(class_no,class_div){
    return this.httpClient.get('/academics/get_class_students/',{params:{'class_no':class_no,'class_div':class_div}});
  }
  getTeacherSubjectClassess(){
    return this.httpClient.get('/academics/class_teacher_subject_assigned/')
  }
  getTeacherSubjectClassessAcademicYear(academic_year){
    return this.httpClient.get('/academics/class_teacher_subject_assigned/',{params:{academic_year}})
  }
  get_class_or_teacher_class_subjects(class_id) {
    return this.httpClient.get('/academics/get_class_or_teacher_class_subjects/',{params:{'class_id':class_id}})
  }
  
}
